import { getQuarter, getYear, parseISO } from "date-fns";
import { InsightsTimeline, ReleaseStatusCount } from "../../types";

export function transformTimelineData(
  timeline: InsightsTimeline,
): Record<string, ReleaseStatusCount> {
  const monthCount = Object.keys(timeline).length;

  if (monthCount <= 12) {
    return timeline;
  }

  const timelinePerQuarter: Record<string, ReleaseStatusCount> = {};

  // Return yearly if more than 10-year timespan, quarterly otherwise
  if (monthCount > 12 * 10) {
    Object.entries(timeline).forEach(([yearMonth, counts]) => {
      const entryDate = parseISO(`${yearMonth}-01`);
      const year = getYear(entryDate);

      if (!timelinePerQuarter[year]) {
        timelinePerQuarter[year] = {
          pass: 0,
          fail: 0,
        };
      }

      timelinePerQuarter[year].pass += counts.pass;
      timelinePerQuarter[year].fail += counts.fail;
    });
  } else {
    Object.entries(timeline).forEach(([yearMonth, counts]) => {
      const entryDate = parseISO(`${yearMonth}-01`);
      const quarter = getQuarter(entryDate);
      const year = getYear(entryDate);
      const timeSlice = `Q${quarter} ${year}`;

      if (!timelinePerQuarter[timeSlice]) {
        timelinePerQuarter[timeSlice] = {
          pass: 0,
          fail: 0,
        };
      }

      timelinePerQuarter[timeSlice].pass += counts.pass;
      timelinePerQuarter[timeSlice].fail += counts.fail;
    });
  }

  Object.entries(timelinePerQuarter).forEach(
    ([time, counts]: [keyof typeof timelinePerQuarter, ReleaseStatusCount]) => {
      if (counts.pass === 0 && counts.fail === 0) {
        delete timelinePerQuarter[time];
      }
    },
  );

  return timelinePerQuarter;
}
